export const MAPPING_REVIEW_PAGE_SIZE = 10;

export const MAPPING_REVIEW_STATUS_OPTIONS = [
  { value: "mapped", label: "Mapped" },
  { value: "pending", label: "Pending" },
  { value: "needs_review", label: "Needs Review" },
  { value: "failed", label: "Failed" },
] as const;

export type MappingReviewStatus =
  (typeof MAPPING_REVIEW_STATUS_OPTIONS)[number]["value"];

export const DELETE_MAPPING_SESSION_CONFIRM = {
  title: "Delete this mapping",
  eyebrow: "Confirm delete",
  description:
    "This permanently removes the mapping session and all of its data (review rows, drafts, tracking, and caches). Approved knowledge that other product types reuse is kept. This cannot be undone.",
  removeSavedAnswersLabel: "Also remove this session's saved answers",
} as const;
